import React from "react";
import {BookingSearchStrategyBase} from "../booking-search-strategy-base";
import {IBookingSearchResultRecord} from "../../../airline-webapi/responses/booking-search.response";
import {BookingSearchStrategyType} from "../booking-search.strategy.interface";
import {FormFields} from "../../../../models/forms/form-field.interface";
import {SearchByRecordLocatorComponent} from "./search-by-record-locator.component";
import {IBookingSearchPagination} from "../../../airline-webapi/requests/booking-search.requests";
import {NullableString} from "../../../../types/nullable-types";
import {locateOutline} from "ionicons/icons";


interface ISearchByRecordLocatorFields {
    recordLocator: string;
}

export class SearchByRecordLocatorStrategy extends BookingSearchStrategyBase<ISearchByRecordLocatorFields, ISearchByRecordLocatorFields> {

    protected _createFilterFields(persistedFields: ISearchByRecordLocatorFields): FormFields<ISearchByRecordLocatorFields> {
        return {
            recordLocator: this._createField({
                fieldName: () => this.services.language.translate("Record locator"),
                defaultValue: persistedFields?.recordLocator ?? null,
                isRequired: true,
            })
        }
    }

    get type(): BookingSearchStrategyType {
        return BookingSearchStrategyType.ByRecordLocator;
    }

    get name(): string {
        return this.services.language.translate("By record locator");
    }

    get resultsDescription(): string {
        return this.services.language.translate("Results by record locator");
    }

    protected _getIonIconName(): NullableString {
        return locateOutline;
    }

    renderSearchFields(): React.ReactElement {
        return (
           <SearchByRecordLocatorComponent strategy={this}/>
        )
    }

    async _searchBookings(sessionToken: string, pagination: IBookingSearchPagination): Promise<IBookingSearchResultRecord[]> {
        const response = await this.services.airlineWebapi.agencyBookingSearchByRecordLocator({
            dotRezToken: sessionToken,
            recordLocator: this.fields.recordLocator.value!,
            pagination: pagination
        });

        return response.results;
    }

    protected _collectFieldsValuesForStorage(): ISearchByRecordLocatorFields {
        return {
            recordLocator: this.fields.recordLocator.value ?? ""
        }
    }
}